<template>
  <v-textarea
    name="concierge_info"
    :value="value.concierge_info"
    :counter="1500"
    rows="3"
    :rules="rules.concierge_info"
    :readonly="readonly"
    :error-messages="errors.concierge_info"
    :label="`${$t('BUILDING_COMPLEXES.CONCIERGE_INFO')}`"
    @input="updateValue('concierge_info', $event)"
  ></v-textarea>
</template>

<script>
import { maxLength } from '@/modules/_global/variables/rules';
import formEditable from '@/modules/_global/mixins/form-editable';

export default {
  name: 'ConciergeInfoForm',

  mixins: [formEditable],

  props: {
    languageId: {
      type: Number,
      required: true
    },
    value: {
      type: Object,
      default: () => ({
        concierge_info: ''
      })
    }
  },

  data() {
    return {
      valid: true,
      rules: {
        concierge_info: [maxLength(1500)]
      }
    };
  },

  mounted() {
    this.$emit('input', { ...this.value, language_id: this.languageId });
  },

  methods: {
    updateValue(key, value) {
      this.$emit('update-prop', key, value);
      this.$emit('input', {
        ...this.value,
        language_id: this.languageId,
        [key]: value
      });
    }
  }
};
</script>
